export default (bpm) => bpm / 60;
